import axios from "utils/axios";
import * as types from "./ActionTypes";
import { API_URL } from "configs";
import { showSuccessModal } from "actions";

const loader = (label) => ({
  type: types.SHOW_LOADER,
  common_loader_label: label,
});
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = "general_error") => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType) => {
  const res = error?.response;
  if (res?.status === 422) {
    dispatch({ type: validationType, validation_error: res.data.errors });
  } else
    dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
};

export const weeklyTimesheetRedirectToList = () => ({
  type: types.WEEKLY_TIMESHEET_REDIRECT,
});

const fetchSuccess = (type, listKey) => (data) => ({
  type,
  [listKey]: data,
});

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action,
});

export const hideWeeklyTimesheetValidationError = (feild_key) => ({
  type: types.HIDE_WEEKLY_TIMESHEET_FEILD_VALIDATION_ERROR,
  feild_key: feild_key,
});

export const fetchWeeklyTimesheets =
  (params = {}) =>
  (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader());

    axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/my-weekly-time-entries`,
        params,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        dispatch(hideLoader());
        dispatch(
          fetchSuccess(
            types.WEEKLY_TIMESHEET_SUCCESS,
            "weeklyTimesheetsList"
          )(res.data)
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
      });
  };

export const fetchAllWeeklyTimesheets =
  (params = {}) =>
  (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader());

    axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/all-weekly-time-entries`,
        params,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        dispatch(hideLoader());
        dispatch(
          fetchSuccess(
            types.WEEKLY_TIMESHEET_SUCCESS,
            "weeklyTimesheetsList"
          )(res.data)
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
      });
  };

export const fetchAllMonthlyTimesheets =
  (params = {}) =>
  (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader());

    axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/all-monthly-time-entries`,
        params,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        dispatch(hideLoader());
        dispatch(
          fetchSuccess(
            types.WEEKLY_TIMESHEET_SUCCESS,
            "weeklyTimesheetsList"
          )(res.data)
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
      });
  };

export const getWeeklyTimesheetById =
  (id, actionType, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader());

    axios
      .get(`${API_URL}timesheet/weekly-timesheets/${id}/details`, {
        params: { object_viewed_id },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        dispatch(hideLoader());
        dispatch(
          getSuccess(types.WEEKLY_TIMESHEET_GET_SUCCESS)(res.data, actionType)
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
      });
  };

export const createOrUpdateWeeklyTimesheet =
  (data, method = "POST", object_viewed_id) =>
  (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader());

    const url =
      method === "POST"
        ? `${API_URL}timesheet/weekly-timesheets`
        : `${API_URL}timesheet/weekly-timesheets/${data.id}`;

    return axios({
      url,
      method,
      data,
      params: { object_viewed_id },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then(() => {
        dispatch(hideLoader());
        dispatch(
          showSuccessModal(
            `Time Tracking ${
              method === "POST" ? "created" : "updated"
            } successfully`
          )
        );
        dispatch(weeklyTimesheetRedirectToList());
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
        return Promise.reject(err);
      });
  };

export const saveDayEntry =
  (weeklyTimesheetId, data, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader("Saving day entry..."));

    axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/${weeklyTimesheetId}/day-entry`,
        data,
        {
          params: { object_viewed_id },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        dispatch(hideLoader());
        dispatch(snackbar("Day entry saved successfully", "success"));
        // Optionally refresh the timesheet data
        // dispatch(fetchWeeklyTimesheets({ object_viewed_id }));
      })
      .catch((err) => {
        dispatch(hideLoader());
        //handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);

        const res = err?.response;
        if (res?.status === 422) {
          dispatch(
            snackbar(res?.data?.message || `${res?.status} ${res?.statusText}`)
          );
        } else
          dispatch(
            snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`)
          );
      });
  };

export const saveComment =
  (weeklyTimesheetId, data, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader("Saving comment..."));

    return axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/${weeklyTimesheetId}/comment`,
        data,
        {
          params: { object_viewed_id },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        dispatch(hideLoader());
        dispatch(snackbar("Comment saved successfully", "success"));
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch(hideLoader());
        const res = err?.response;
        if (res?.status === 422) {
          dispatch(
            snackbar(res?.data?.message || `${res?.status} ${res?.statusText}`)
          );
        } else {
          dispatch(
            snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`)
          );
        }
        return Promise.reject(err);
      });
  };

export const deleteWeeklyTimesheet = (id, object_viewed_id) => (dispatch) => {
  dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
  dispatch(loader());

  return axios
    .delete(`${API_URL}timesheet/weekly-timesheets/${id}`, {
      params: { object_viewed_id },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(() => {
      dispatch(hideLoader());
      dispatch(snackbar("Weekly timesheet deleted successfully", "success"));
      dispatch(weeklyTimesheetRedirectToList());
      return Promise.resolve();
    })
    .catch((err) => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
      return Promise.reject(err);
    });
};

export const deleteWeeklyTimesheetEntry =
  (id, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader());

    return axios
      .delete(`${API_URL}timesheet/weekly-timesheets/${id}/entry`, {
        params: { object_viewed_id },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        dispatch(hideLoader());
        dispatch(
          snackbar("Weekly timesheet entry deleted successfully", "success")
        );
        dispatch(weeklyTimesheetRedirectToList());
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
        return Promise.reject(err);
      });
  };

// Team Weekly Timesheet Actions - Separate endpoints for team operations
export const saveTeamDayEntry =
  (weeklyTimesheetId, data, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader("Saving day entry..."));

    axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/${weeklyTimesheetId}/day-entry`,
        data,
        {
          params: { object_viewed_id },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        dispatch(hideLoader());
        dispatch(snackbar("Day entry saved successfully", "success"));
      })
      .catch((err) => {
        dispatch(hideLoader());
        const res = err?.response;
        if (res?.status === 422) {
          dispatch(
            snackbar(res?.data?.message || `${res?.status} ${res?.statusText}`)
          );
        } else
          dispatch(
            snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`)
          );
      });
  };

export const createWeekDayEntries =
  (data, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader("Saving day entry..."));

    axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/create-week-day-entries`,
        data,
        {
          params: { object_viewed_id },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        dispatch(hideLoader());
        dispatch(snackbar("Day entry saved successfully", "success"));
        // trigger list reload by setting redirectToList flag
        dispatch(weeklyTimesheetRedirectToList());
      })
      .catch((err) => {
        dispatch(hideLoader());
        const res = err?.response;
        if (res?.status === 422) {
          dispatch(
            snackbar(res?.data?.message || `${res?.status} ${res?.statusText}`)
          );
        } else
          dispatch(
            snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`)
          );
      });
  };

export const saveTeamComment =
  (weeklyTimesheetId, data, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader("Saving comment..."));

    return axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/${weeklyTimesheetId}/comment`,
        data,
        {
          params: { object_viewed_id },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        dispatch(hideLoader());
        dispatch(snackbar("Comment saved successfully", "success"));
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch(hideLoader());
        const res = err?.response;
        if (res?.status === 422) {
          dispatch(
            snackbar(res?.data?.message || `${res?.status} ${res?.statusText}`)
          );
        } else {
          dispatch(
            snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`)
          );
        }
        return Promise.reject(err);
      });
  };

export const createTeamMonthlyTimesheets =
  (data, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader("Creating monthly entry..."));

    return axios
      .post(
        `${API_URL}timesheet/weekly-timesheets/create-month-day-entries`,
        data,
        {
          params: { object_viewed_id },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        dispatch(hideLoader());
        dispatch(showSuccessModal("Monthly time entry created successfully"));
        dispatch(weeklyTimesheetRedirectToList());
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
        return Promise.reject(err);
      });
  };

export const createOrUpdateTeamWeeklyTimesheet =
  (data, method = "POST", object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader());

    const url =
      method === "POST"
        ? `${API_URL}timesheet/weekly-timesheets`
        : `${API_URL}timesheet/weekly-timesheets/${data.id}`;

    return axios({
      url,
      method,
      data,
      params: { object_viewed_id },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then(() => {
        dispatch(hideLoader());
        dispatch(
          showSuccessModal(
            `Time Tracking ${
              method === "POST" ? "created" : "updated"
            } successfully`
          )
        );
        dispatch(weeklyTimesheetRedirectToList());
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
        return Promise.reject(err);
      });
  };

export const deleteTeamWeeklyTimesheetEntry =
  (id, object_viewed_id) => (dispatch) => {
    dispatch({ type: types.WEEKLY_TIMESHEET_REQUEST });
    dispatch(loader());

    return axios
      .delete(`${API_URL}timesheet/weekly-timesheets/${id}/entry`, {
        params: { object_viewed_id },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        dispatch(hideLoader());
        dispatch(
          snackbar("Weekly timesheet entry deleted successfully", "success")
        );
        dispatch(weeklyTimesheetRedirectToList());
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
        return Promise.reject(err);
      });
  };

export const exportTeamWeeklyTimesheet = (params = {}, object_viewed_id) => dispatch => {
  dispatch(loader('Exporting...'));

  axios.post(
    `${API_URL}timesheet/weekly-timesheets/export`,
    params,                        // <-- ensure week_end_date is inside params
    {
      params: { object_viewed_id },
      responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(res => {
    dispatch(hideLoader());
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    const contentDisposition = res.headers['content-disposition'];
    let fileName = 'team_weekly_timesheet.xlsx';
    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch.length === 2)
            fileName = fileNameMatch[1];
    }
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  })
  .catch(err => {
    dispatch(hideLoader());
    handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
  });
};

export const exportTeamMonthlyTimesheet = (params = {}, object_viewed_id) => dispatch => {
  dispatch(loader('Exporting...'));

  axios.post(
    `${API_URL}timesheet/weekly-timesheets/monthly-export`,
    params,                        // <-- ensure month_year is inside params
    {
      params: { object_viewed_id },
      responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(res => {
    dispatch(hideLoader());
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    const contentDisposition = res.headers['content-disposition'];
    let fileName = 'team_monthly_timesheet.xlsx';
    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch.length === 2)
            fileName = fileNameMatch[1];
    }
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  })
  .catch(err => {
    dispatch(hideLoader());
    handleError(err, dispatch, types.WEEKLY_TIMESHEET_VALIDATION_ERROR);
  });
};